import {ErrorHandler, Injectable, Injector} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {ErrorModalComponent} from "../../components/error-modal/error-modal.component";
import {logger} from '../services/logging.service';
import {PosthogService} from '../services/posthog.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        public dialog: MatDialog,
        private injector: Injector
    ) {}

    handleError(error: any) {
        this.injector.get(PosthogService).captureException(error);

        //if its an internal error, show the error message in a dialog
        if(!(error instanceof HttpErrorResponse)) {
            logger.error('Error from global error handler', error);
            try {
                if (error.message == null || error.message.indexOf("auth/")) {
                    //Auth error, not showing dialog
                    return;
                }
            }
            catch (e) {
                logger.error('Error from global error handler', e);
            }
            this.dialog.open(ErrorModalComponent, {
                panelClass: 'modal-background',
                data: {
                    message: error.message,
                    stacktrace: error.stack
                }
            });
        }
    }
}
